(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var flickityElement = document.querySelector('.js-flickity');
  var flickityInstance = new Flickity(flickityElement, {
    wrapAround: true,
    pageDots: false
  });

  document.querySelectorAll('.stl-hotspot').forEach(hotspot => {
    hotspot.addEventListener('click', () => {
      const index = parseInt(hotspot.getAttribute('data-index'));
      flickityInstance.select(index);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
